import { useEffect, useRef } from 'react';
import { useChatStore } from '../stores/chatStore';
import MessageItem from './MessageItem';

interface MessageListProps {
  onScrollToBottom: () => void;
}

export default function MessageList({ onScrollToBottom }: MessageListProps) {
  const { messages, isStreaming, streamingContent } = useChatStore();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    onScrollToBottom();
  }, [messages, streamingContent, onScrollToBottom]);

  if (messages.length === 0 && !isStreaming) {
    return (
      <div className="flex-1 flex items-center justify-center text-gray-500">
        <p>Start a conversation...</p>
      </div>
    );
  }

  return (
    <div ref={containerRef} className="space-y-6 p-6">
      {messages.map((message, index) => (
        <MessageItem
          key={message.id}
          message={message}
          isLast={index === messages.length - 1 && !isStreaming}
        />
      ))}
      
      {isStreaming && (
        <MessageItem
          message={{
            id: 'streaming',
            role: 'assistant',
            content: streamingContent,
            createdAt: new Date().toISOString(),
          }}
          isStreaming={true}
          isLast={true}
        />
      )}
    </div>
  );
}
